import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pc-block" }
const _hoisted_2 = { class: "head flex-between" }
const _hoisted_3 = { class: "light" }

import { watch, computed } from "vue";
import { filterHash } from "@/utils/filters";
import HomeMixins from "@/mixins/home";
import Count from "@/components/common/Count.vue";
import Store from "@/store/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlockArea',
  setup(__props) {

const { block, checkNewBlock } = HomeMixins();
const maxHeight = computed(() => Store.state.maxHeight);

watch(
  maxHeight,
  () => {
    checkNewBlock();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "最新区块", -1)),
      _createVNode(_component_router_link, {
        to: "/block",
        class: "link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("查看全部")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _unref(block).list,
      stripe: "",
      style: {"width":"100%"},
      class: "data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "高度",
          align: "center",
          width: "200"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/blockdetail?height=${item.row.height}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.row.height), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "hash",
          label: "区块哈希",
          align: "center"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/blockdetail?height=${item.row.height}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.hash, 20)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "txCount",
          label: "数据数量",
          align: "center",
          width: "300"
        }, {
          default: _withCtx((item) => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.row.txCount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "blockTime",
          label: "块龄",
          align: "center",
          width: "200"
        }, {
          default: _withCtx((item) => [
            _createVNode(Count, {
              time: item.row.blockTime
            }, null, 8, ["time"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})